import { render } from "./OrgDetailsForm.vue?vue&type=template&id=693f7fb4&scoped=true"
import script from "./OrgDetailsForm.vue?vue&type=script&lang=js"
export * from "./OrgDetailsForm.vue?vue&type=script&lang=js"

import "./OrgDetailsForm.vue?vue&type=style&index=0&id=693f7fb4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693f7fb4"]])

export default __exports__